export function permissionKey(moduleName, action, fieldKey = null) {
  return [moduleName, action, fieldKey || ""].join(":");
}

export function policyKey(moduleName, action) {
  return [moduleName, action].join(":");
}

export function hasPermission(user, moduleName, action, fieldKey = null) {
  if (user?.isSuperAdmin) return true;

  const policySummary = user?.policy_summary || {};
  if (policySummary?.[policyKey(moduleName, action)]?.denied) return false;

  const permissions = Array.isArray(user?.permissions) ? user.permissions : [];
  const exactKey = permissionKey(moduleName, action, fieldKey);
  const genericKey = permissionKey(moduleName, action, null);

  const denied = permissions.some((permission) => {
    if (permission.effect !== "deny") return false;
    const key = permission.key || permissionKey(permission.module, permission.action, permission.field_key);
    if (fieldKey) {
      return key === exactKey;
    }
    return key === genericKey;
  });
  if (denied) return false;

  return permissions.some((permission) => {
    if (permission.effect !== "allow") return false;
    const key = permission.key || permissionKey(permission.module, permission.action, permission.field_key);
    if (fieldKey) {
      return key === exactKey;
    }
    return key === genericKey;
  });
}

export function getPrimaryRoleName(user) {
  if (user?.effective_role_name) return user.effective_role_name;
  if (user?.role_name) return user.role_name;
  if (Array.isArray(user?.roles) && user.roles[0]?.name) return user.roles[0].name;
  return user?.role_id ? `Role #${user.role_id}` : "User";
}

export function getPolicySummary(user, moduleName, action) {
  return user?.policy_summary?.[policyKey(moduleName, action)] || null;
}
